import axios from 'axios';
// Same-origin: the embedded server (server/index.js) hosts both the site and the API.
// In dev, CRA proxies /api to localhost:3001 (see "proxy" in package.json).
export const baseUrl = '';

export const AxiosService = axios.create({
	baseURL: baseUrl,
	timeout: 15000
});
